// extracted by mini-css-extract-plugin
module.exports = {"component":"InfoPage_component__2imQ-","wrapper":"InfoPage_wrapper__33v5K","content":"InfoPage_content__vmxBV","buttons":"InfoPage_buttons__qpMqw"};